import { ReEvaluateDialog as SharedReEvaluateDialog } from '@shared-ui/question-result';
import type { AdjustmentWhyValue } from '@shared-ui/components';

interface ReEvaluateDialogProps {
    onClose: () => void;
    /** `why` — whose side, what exactly, a note for our records. Optional on a
     *  re-evaluation; never sent to the model. */
    onRun: (note?: string, why?: AdjustmentWhyValue) => void;
}

/**
 * The admin console's re-evaluate dialog — the shared one the teacher sees, so
 * both say the same about where each field goes (to the AI, to our records, to
 * the student). Mounted only while open. Ungated for admins.
 *
 * See docs/FeatureDesigns/solution-analysis/reevaluation-note.md.
 */
export function ReEvaluateDialog({ onClose, onRun }: ReEvaluateDialogProps) {
    return <SharedReEvaluateDialog open askWhy onClose={onClose} onConfirm={onRun} />;
}
